/**
 * matchPlayCard.tsx
 * 
 * @copyright jnakaso.com
 * 
 *  home page
 * 
 */

import { Card, Center, Flex, ScrollArea, Tabs, TabsList, TabsPanel, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { storageService } from "src/services/storageService";


export function TournamentBracket(props: { bracket?: any }) {

    const match = (match: any, idx) => {
        return <React.Fragment key={idx}>
            <li className="spacer" >&nbsp;</li>
            <li className="game game-top" >{match.top}</li>
            <li className="game game-spacer" >&nbsp;</li>
            <li className="game game-bottom">{match.bottom}</li>
        </React.Fragment>
    }

    const emptyMatch = (idx) => {
        return <React.Fragment key={idx}>
            <li className="spacer">&nbsp;</li>
            <li className="game">&nbsp;</li>
            <li className="game">&nbsp;</li>
            <li className="game ">&nbsp;</li>
        </React.Fragment>
    }
    const winner = (match, idx) => {
        return <React.Fragment key={idx}>
            <li className="spacer">&nbsp;</li>
            <li className="game game-top">{match.top}</li>
        </React.Fragment>
    }

    return <ScrollArea style={{ overflowY: "auto" }}>
        <Flex direction={"row"}>
            {props.bracket.map((r, idx) =>
                <ul key={idx} className={`round round-${idx}`}>
                    <li className="course"><div>{r.course}</div></li>
                    {r.matches.map((m, idx) =>
                        m.top && m.bottom
                            ? match(m, idx)
                            : (m.top && !m.bottom)
                                ? winner(m, idx)
                                : emptyMatch(idx))}
                    <li className="spacer">&nbsp;</li>
                </ul>
            )}
        </Flex>
    </ScrollArea>
}

export function MatchPlayCard(props: { season: number }) {
    const [aGrossMatch, setGrossMatch] = useState([]);
    const [aNetMatch, setNetMatch] = useState([]);
    const [bMatch, setBMatch] = useState([]);

    useEffect(() => {
        if (props.season) {
            storageService.getSeasonFile(props.season, 'a-gross-match.json')
                .then(t => setGrossMatch(JSON.parse(t)))
                .catch(e => console.error('Reading a-gross-match', e));
            storageService.getSeasonFile(props.season, 'a-net-match.json')
                .then(t => setNetMatch(JSON.parse(t)))
                .catch(e => console.error(e));
            storageService.getSeasonFile(props.season, 'b-match.json')
                .then(t => setBMatch(JSON.parse(t)))
                .catch(e => console.error(e));
        }
    }, [props])
    return <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Card.Section>
            <Center h={60} bg="var(--mantine-color-gray-light)">
                <Text fw={800} >{props.season} Match Play Results</Text>
            </Center>
        </Card.Section>
        <Tabs defaultValue="a-gross" >
            <TabsList>
                <Tabs.Tab value="a-gross">
                    <Text fw={800} >A - Flight Gross</Text>
                </Tabs.Tab>
                <Tabs.Tab value="a-net">
                    <Text fw={800} >A - Flight Net</Text>
                </Tabs.Tab>
                <Tabs.Tab value="b-net">
                    <Text fw={800} >B - Flight Net</Text>
                </Tabs.Tab>
            </TabsList>
            <TabsPanel value="a-gross"><TournamentBracket bracket={aGrossMatch} /></TabsPanel>
            <TabsPanel value="a-net"><TournamentBracket bracket={aNetMatch} /></TabsPanel>
            <TabsPanel value="b-net"><TournamentBracket bracket={bMatch} /></TabsPanel>
        </Tabs>
    </Card >
}

